//#region Controls

const controlActions = {
    ACT: 1
}
const relationActionTypes = {
    NONE: 0,
    RENDER: 1,
    FILTER: 2
}
const controlEvents = {
    ACT: 'kdr-control-act',
    AFTER_RENDER: 'kdr-control-after-render',
    AFTER_UI_INIT: 'kdr-control-ui-init',
    AFTER_FILTER: 'kdr-control-ui-init',
    BEFORE_RENDER: 'kdr-control-before-render',
    BEFORE_PARSE_COMMAND: 'kdr-control-before-parse-command'
}

var controls = {
    getArgs: function (inputs, args) {
        for (var i = 0; i < inputs.length; i++) {
            let $i = convert.toJqueryObject(inputs[i])
            let di = $i.attr("data-index").toString()

            if ($i.hasClass('kdr-grid-input-tinymc-wrapper') || $i.hasClass('kdr-grid-input-newtinymc-wrapper')) {
                let $editor = tinyMCE.get($i.prop('id'))
                let t0 = $editor.getContent()
                let isHideToolbar = $i.hasClass('tinymce-hide-toolbar')

                if ($i.hasClass('regex-mail-marker')) {
                    const regex = /<span\s*(?:class=["|\s|\w]*[marker|marker\-section["|\s|\w]*)\s*data-value="(.*?)">.*?<\/span>/gi;
                    let m = null
                    let t = t0              /* 20211203 niech to sie dzieje w sqlu, zeby zapewnic konsystencje miedzy tym co wyszlo a tym co przyszlo (tlumaczenia) -dkowalski */
                    /*                                js'ie jak juz**/
                    while ((m = regex.exec(t0)) !== null) {
                        // This is necessary to avoid infinite loops with zero-width matches
                        if (m.index === regex.lastIndex) {
                            regex.lastIndex++;
                        }

                        t = t.replace(m[0], m[1])
                    }

                    t0 = t
                }

                t0 = t0.replace('<em>', '<i>').replace('</em>', '</i>')
                if (isHideToolbar === true) {
                    t0 = t0.replace(/<\/?[^>]+(>|$)/g, "");///potentially danger
                }

                /*args[di] = text*/
                if ($i.hasClass('kdr-language')) {
                    let l = $($i.closest('[data-language]')).data('language')
                    if (args[di] == undefined) {
                        args[di] = {}
                    }
                    args[di][l] = t0
                } else {
                    args[di] = t0
                }//
            }
            else if ($i.hasClass('checkbox-tristate-input')) {
                args[di] = nullIf($i.valExtended(), 'indeterminate')
            }
            else if ($i.hasClass('kdr-language')) {
                let l = $($i.closest('[data-language]')).data('language')
                if (args[di] == undefined) {
                    args[di] = {}
                }
                args[di][l] = $i.valExtended()
            }
            else if ($i.hasClass('kdr-grid-input-file-list')) {
                //clyson potem jesli wiesz jak mozesz dac to od extended value - nie wiem radeon
                args[di] = $i.find('.kdr-grid-file-item').map(function (index, item) { return $(item).data('index') }).toArray()
            }
            else if ($i.hasClass('nav-link')) {
                args[di] = $i.data('value')
            }
            else if ($i.hasClass('kdr-kanban')) {
                args[di] = $i.find('.kanban-task.kanbanSelected').data('index')
            }
            else if ($i.hasClass('kdr-form-steps')) {
                args[di] = $i.find('.kdr-node-element.kdr-form-steps-node-selected, .kdr-node-element-end.kdr-form-steps-node-selected').find('.node-parameter').attr('data-p')
            }
            else if ($i.hasClass('kdr-questions-parameter')) {
                var answers = []

                answers.push({
                    answer: $i.find('.answer-input').valExtended(),
                    points: $i.find('.points-input').valExtended()
                })

                args[di] = answers
            }
            else if ($i.hasClass('kdr-answers-table')) {
                let $elements = $i.find('tr.kdr-ddl-custom-tr-pattern-inputs')
                var answers = []

                $elements.each(function (index, element) {
                    let answerTexts = {}
                    $(element).find('.answer-input').each(function (aIndex, $element) {
                        let l = $($element).closest('[data-language]').data('language')
                        answerTexts[l] = $($element).valExtended()
                    });

                    answers.push({
                        answer: answerTexts,
                        points: $(element).find('.points-input').valExtended(),
                        commentRequiredP: $(element).find('.comment-requirement-input').valExtended()
                    })
                });

                args[di] = answers
            }
            else if ($i.hasClass('answers-tables-container')) {
                let $elements = [
                    $i.find('.kdr-questions-rows-table tr.kdr-ddl-custom-tr-pattern-inputs').toArray(),
                    $i.find('.kdr-questions-columns-table tr.kdr-ddl-custom-tr-pattern-inputs').toArray()
                ];
                var answers = []
                let i = 0


                $elements.forEach(group => {
                    i++;
                    group.forEach(element => {
                        let answerTexts = {}
                        $(element).find('.answer-input').each(function (aIndex, $element) {
                            let l = $($element).closest('[data-language]').data('language')
                            answerTexts[l] = $($element).valExtended()
                        });

                        answers.push({
                            answer: answerTexts,
                            points: $(element).find('.points-input').valExtended(),
                            type: i == 1 ? 'ROW' : 'COLUMN'
                        });
                    });
                });

                args[di] = answers
            }
            else if ($i.hasClass('kdr-questions-linear-scale')) {

                var answers = []

                let answerTexts = {}
                $i.find('.answer-input.from-input').each(function (aIndex, $element) {
                    let l = $($element).closest('[data-language]').data('language')
                    answerTexts[l] = $($element).valExtended()
                });

                answers.push({
                    answer: answerTexts,
                    points: $i.find('.points-input-from').valExtended(),
                    type: $i.find('.from-input-ddl').valExtended()
                });

                answerTexts = {}
                $i.find('.answer-input.to-input').each(function (aIndex, $element) {
                    let l = $($element).closest('[data-language]').data('language')
                    answerTexts[l] = $($element).valExtended()
                });
                answers.push({
                    answer: answerTexts,
                    points: $i.find('.points-input-to').valExtended(),
                    type: $i.find('.to-input-ddl').valExtended()
                });


                args[di] = answers
            }
            else if ($i.hasClass('kdr-dropdown-questions-parameter')) {
                var ddlValues = {
                    randomizeP: $i.find('.randomize-input-p input').valExtended(),
                    scoredP: $i.find('.kdr-questions-scored input').valExtended(),
                    commentP: $i.find('.kdr-questions-question-comment input').valExtended()
                }
                args[di] = ddlValues
            }
            else if ($i.hasClass('jstree-checkbox-selection') && $i.jstree().settings.core.multiple) {
                args[di] = $i.jstree('get_selected')
            }
            else if ($i.hasClass('kdr-filters-input-checbox-ddl')) {
                let $selected = $i.children().map(function () {
                    return $(this).find('input:checked').get();
                });

                let valueToSend = []

                for (let i = 0; i < $selected.length; i++) {
                    valueToSend.push($($selected[i]).data('value'))
                }

                args[di] = valueToSend
            }
            else if ($i.hasClass('time-from-to') || $i.hasClass('date-time-from-to')) {
                let value = $i.val()
                let valueNullOrEmptyP = textHelper.isNullOrEmpty(value)
                let dateTimeP = $i.hasClass('date-time-from-to')

                if (valueNullOrEmptyP || dateTimeHelper.stringIsValidTime(value) || (dateTimeP === true && !value.includes('_'))) {
                    const fromModeKey = 'from'
                    const toModeKey = 'to'
                    let convertedValue = null;
                    if (!valueNullOrEmptyP) {
                        if ($i.hasClass('time-from-to')) {
                            convertedValue = convert.timeToUTCTimeString(value)
                        }
                        else if (dateTimeP === true) {
                            convertedValue = value
                        }
                    }


                    let mode = $i.data('time-mode')
                    if (args[di] == undefined) {
                        args[di] = {
                            fromModeKey: null,
                            toModeKey: null
                        }
                    }

                    if (mode == fromModeKey) {
                        args[di][fromModeKey] = convertedValue
                    } else if (mode == toModeKey) {
                        args[di][toModeKey] = convertedValue
                    } else {
                        console.error('Incorrect mode in input:')
                        console.error($i)
                    }
                } else {
                    console.error('Incorrect value in input:')
                    console.error($i)
                }
            }
            else {
                args[di] = $i.valExtended()

                ///dodawanie nowych elementow przez ddl'e, nie pozdrawiam
                if ($i.data('addInput') && isNaN(args[di])) {
                    let negativeIdex = di * -1 - 100
                    let valueToSend;
                    if ($i.data('addInputWLang') === true) {
                        let langs = {}
                        $(`.kdr-dropdown-w-search-item[data-value="${args[di]}"] .kdr-dropdown-w-search-item-text span`).each(function () {
                            langs[this.dataset.lang] = this.textContent.trim()
                        })
                        valueToSend = langs
                    } else {
                        valueToSend = $(`.kdr-dropdown-w-search-item[data-value="${args[di]}"] .kdr-dropdown-w-search-item-text`)?.text()?.trim()
                    }

                    args[negativeIdex] = valueToSend
                }
            }
        }
    },
    setArgs: function (inputs, args, asyncDDLP = true) {
        inputs.each(function (a, b) {
            let $input = $(b)
            let di = $input.attr("data-index").toString()
            $input.valExtended(args[di], undefined, asyncDDLP)
        })
    },
    getMaxUploadSize: function ($control) {
        return $control.data('maxUploadSize')
    },
    getInfo: function (control) {
        //return control.find(".kdr-info").val()
        let id = control.prop('id')
        return $(`#${id}-info`).val()
        //return control.find(".kdr-info").last().val()
    },
    setInfo: function (control, info) {
        //console.log(info)
        let id = control.prop('id')
        return $(`#${id}-info`).val(info)
        //return control.find(".kdr-info").val(info)
    },
    /**
     * Provides refresh grid control by passing here control as object or controlID as string without hash
     * |Automated controls.render|
     * @param {any} control
     * @param {any} endpoint
     * @param {any} controlId
     * @param {any} $loadingTarget
     * @param {any} clearP -- czyszczenie filtrow
     */
    refresh: function (control = null, controlId = null, $loadingTarget = null, endpoint = null, clearP = false, successCallback = null, clearCheckboxesP = false, clearPostbackP = false) {
        let $control = null

        if (control != null) {
            $control = convert.toJqueryObject(control)
        } else if (controlId != null) {
            $control = $('#' + controlId)
        } else {
            console.error('controls.refresh - You need to pass at least one selector')
            return
        }

        if (endpoint == null) {
            endpoint = controls.getEndpoint($control)
        }

        controls.render(endpoint, $control, controls.getInfo($control), $loadingTarget, successCallback, null, clearP, clearCheckboxesP, clearPostbackP)
    },
    render: function (endpoint, control, info, $loadingTarget = null, successCallback = null, selectP = false, clearP = false, clearCheckboxesP = false, clearPostbackP = false) {
        let $control = convert.toJqueryObject(control)

        if (endpoint == 'IgnoreFilter') {
            return;
        }

        if ($loadingTarget == undefined || $loadingTarget.length == 0 || $loadingTarget == null) {
            if ($control.closest('.modal-content').length > 0) {
                $loadingTarget = $control.closest('.modal-content')
            }
            else if ($(control).closest('.tilemenu-row').length > 0) {
                $loadingTarget = $control.closest('.tilemenu-row')
            } else {
                $loadingTarget = $control
            }
        }

        let controlId = $(control).attr('id')

        $.ajax({
            type: "POST",
            url: __root + endpoint,
            datatype: "json",
            traditional: true,
            data: {
                "info": info,
                "selectP": selectP,
                "clearP": clearP,
                "clearCheckboxesP": clearCheckboxesP,
                "clearPostbackP": clearPostbackP
            },
            success: function (response) {
                $control.replaceWith(response)

                successCallback && successCallback(controls.getControl(controlId))
            },
            error: function (r) {
                console.error("Something went wrong, try again later.")
                console.error(controlId)
                console.error(r)
            },
            beforeSend: function () {
                loading.show($loadingTarget)
            },
            complete: () => {
                loading.hide($loadingTarget)
            }
        })
    },
    refreshWithInputs: function (control = null, controlId = null, $loadingTarget = null, endpoint = null, clearP = false, successCallback = null, newValue = null) {
        let $control = null

        if (control != null && control.length != 0) {
            $control = $(control)
        } else if (controlId != null) {
            $control = $('#' + controlId)
        } else {
            console.error('controls.refreshWithInputs - You need to pass at least one selector')
            return
        }

        if (endpoint == null) {
            endpoint = controls.getEndpoint($control)
        }

        controls.renderWithInputs(endpoint, $control, controls.getInfo($control), $loadingTarget, successCallback, null, clearP, newValue)
    },
    clearPayload: function ($control) {
        $.ajax({
            type: "POST",
            url: window.location.origin + __root + 'Grid/ClearPayload',
            datatype: "json",
            traditional: true,
            data: {
                info: controls.getInfo($control)
            },
            success: function (response) {
                if (3 != response.code) {
                    controls.setInfo($control, response.info)
                    controls.refresh($control)
                } else {
                    modal.getModal.danger(__l.Error, response.message, true)
                }
            },
        })
    },
    renderWithInputs: function (endpoint, control, info, $loadingTarget = null, successCallback = null, selectP = false, clearP = false, newValue = null) {
        let dargs = {}
        let gridId = control.attr("id")

        let modalP = control.find(".kdr-grid-modal-item-update").length > 0

        function _replaceNewValue(index, nv, $inputs) {

            if (nv != null && nv.value != null && nv.itemOrdinal == $inputs.closest("td[data-item-ordinal]").data("itemOrdinal")) {
                if (Array.isArray(dargs[index].args[nv.index])) {
                    dargs[index].args[nv.index].push(nv.value)
                } else {
                    dargs[index].args[nv.index] = nv.value
                }
            }
        }

        if (modalP) {
            let modalSelector = "#copied-grid-edit-modal-" + gridId + ", #copied-grid-add-modal-" + gridId
            $(modalSelector).find(".kdr-grid-item-update, .kdr-grid-item-insert, .kdr-grid-item-insert").each(function (index, item) {
                let $item = $(item)
                //let inputs = $item.find(".kdr-grid-input")
                let $inputs = $item.find(".kdr-grid-input") //$(inputs)

                dargs[index] = {
                    index: $item.closest(".modal").data("row-id"),
                    args: []
                }
                controls.getArgs($inputs, dargs[index].args)
                $inputs.each(function (i, e) {
                    let $input = $inputs.eq(i)
                    let i7 = $input.data("index")
                    if ($input.hasClass('kdr-dropdown-w-search-item_selected')) {
                        if (Array.isArray(dargs[index].args[i7])) {
                            $(dargs[index].args[i7]).each(function (ii, ee) {
                                dargs[index].args[i7][ii] = kdrDropdown
                                    .getTogglerMenu($input)
                                    .find(".kdr-dropdown-w-search-item[data-value=" + ee + "]").text().trim()
                            })
                        }
                        else {
                            dargs[index].args[i7] = kdrDropdown
                                .getTogglerMenu($input)
                                .find(".kdr-dropdown-w-search-item[data-value=" + dargs[index].args[i7] + "]").text().trim()
                        }
                    } else if ($input.hasClass('kdr-grid-input-file-list')) {
                        let $input = $input.siblings('.kdr-grid-files-input')

                        dargs[index].args[i7] = controls.fileControl.getFiles($input)
                    }
                })

                _replaceNewValue(index, newValue, $inputs)

                if ($loadingTarget == undefined || $loadingTarget.length == 0 || $loadingTarget == null) {
                    if ($(control).closest('.modal-content').length > 0) {
                        $loadingTarget = $(control).closest('.modal-content')
                    }
                    else if ($(control).closest('.tilemenu-row').length > 0) {
                        $loadingTarget = $(control).closest('.tilemenu-row')
                    } else {
                        $loadingTarget = $(control)
                    }
                }

            })


            controls.render(endpoint, control, info, $loadingTarget, function (hehe) {
                let idx = dargs[0].index
                gridId = hehe.attr('id')

                ReplaceDisplayedEditRow(idx, gridId)
                ReplaceDisplayedInsertRow(gridId)

                $(modalSelector).find(".kdr-grid-item-update, .kdr-grid-item-insert, .kdr-grid-item-insert").each(function (index, item) {
                    let $item = $(item)

                    let $inputs = $item.find(".kdr-grid-input")
                    $inputs.each(function (i, e) {
                        let $input = $inputs.eq(i)
                        let i7 = $input.data("index")
                        if ($input.hasClass('kdr-dropdown-w-search-item_selected')) {
                            if (Array.isArray(dargs[index].args[i7])) {
                                $(dargs[index].args[i7]).each(function (ii, ee) {
                                    let a = kdrDropdown
                                        .getTogglerMenu($input)
                                        .find(".kdr-dropdown-w-search-item")
                                        .filter(function () { return $(this).find(".kdr-dropdown-w-search-item-text").text().trim() == ee })
                                    if (a != undefined) {
                                        let valueToRemove = $(a).data("value");
                                        if ($input.data("value").indexOf(valueToRemove) !== -1) {
                                            dargs[index].args[i7][ii] = undefined;
                                        } else {
                                            dargs[index].args[i7][ii] = valueToRemove;
                                        }
                                    }
                                })
                            } else {
                                let a = kdrDropdown
                                    .getTogglerMenu($input)
                                    .find(".kdr-dropdown-w-search-item")
                                    .filter(function () { return $(this).find(".kdr-dropdown-w-search-item-text").text().trim() == dargs[index].args[i7] })
                                if (a != undefined) {
                                    dargs[index].args[i7] = $(a).data("value")
                                }
                            }
                        } else if ($input.hasClass('kdr-grid-input-file-list')) {
                            let $input = $input.siblings('.kdr-grid-files-input')
                            controls.fileControl.setFiles($input, $(dargs[index].args[i7]))
                            controls.fileControl.refreshUI($input)
                        }
                    })

                    controls.setArgs($inputs, dargs[index].args, false)
                })

                successCallback && successCallback(hehe)
                controls.onGridAfterRenderWInputs(hehe)
            }, selectP, clearP)

        }
        else {
            let editAllP = control.find(".kdr-grid-save-all:visible").length > 0

            control.find(".kdr-grid-item-update, .kdr-filters-groups, .kdr-grid-item-insert").each(function (index, item) {
                let $item = $(item)
                //let inputs = $item.find(".kdr-grid-input, .kdr-filters-input")
                let $inputs = $item.find(".kdr-grid-input, .kdr-filters-input") //$(inputs)

                dargs[index] = {
                    editp: $item.is(":visible"),
                    args: []
                }
                controls.getArgs($inputs, dargs[index].args)

                $inputs.each(function (i, e) {
                    let $input = $inputs.eq(i)
                    let i7 = $input.data("index")
                    if ($input.hasClass('kdr-dropdown-w-search-item_selected')) {
                        if (Array.isArray(dargs[index].args[i7])) {
                            $(dargs[index].args[i7]).each(function (ii, ee) {
                                dargs[index].args[i7][ii] = kdrDropdown
                                    .getTogglerMenu($input)
                                    .find(".kdr-dropdown-w-search-item[data-value=" + ee + "]").text().trim()
                            })
                        }
                        else {
                            dargs[index].args[i7] = kdrDropdown
                                .getTogglerMenu($input)
                                .find(".kdr-dropdown-w-search-item[data-value=" + dargs[index].args[i7] + "]").text().trim()
                        }
                    } else if ($input.hasClass('kdr-grid-input-file-list')) {
                        let $fileInput = $input.siblings('.kdr-grid-files-input')

                        dargs[index].args[i7] = controls.fileControl.getFiles($fileInput)
                    }
                })

                _replaceNewValue(index, newValue, $inputs)



            })

            controls.render(endpoint, control, info, $loadingTarget, function (hehe) {

                hehe.find(".kdr-grid-item-update, .kdr-filters-groups, .kdr-grid-item-insert").each(function (index, item) {
                    let $item = $(item)
                    if (dargs[index] != undefined && dargs[index].editp) {
                        let index = $item.index() - 1
                        if (index >= 0) {
                            let $select = $($item.parent().children().get(index))
                            $item.addClass('show').show()
                            $select.removeClass('show').hide()
                        }
                    }
                    let $inputs = $item.find(".kdr-grid-input, .kdr-filters-input")
                    $inputs.each(function (i, e) {
                        let $input = $inputs.eq(i)
                        let i7 = $input.data("index")
                        if ($input.hasClass('kdr-dropdown-w-search-item_selected')) {
                            if (Array.isArray(dargs[index].args[i7])) {
                                $(dargs[index].args[i7]).each(function (ii, ee) {
                                    let a = kdrDropdown
                                        .getTogglerMenu($input)
                                        .find(".kdr-dropdown-w-search-item").filter(function () { return $(this).find(".kdr-dropdown-w-search-item-text").text().trim() == ee })
                                    if (a != undefined) {
                                        let valueToRemove = $(a).data("value");
                                        if ($input.data("value").indexOf(valueToRemove) !== -1) {
                                            dargs[index].args[i7][ii] = undefined;
                                        } else {
                                            dargs[index].args[i7][ii] = valueToRemove;
                                        }
                                    }
                                })
                            } else {
                                let a = kdrDropdown
                                    .getTogglerMenu($input)
                                    .find(".kdr-dropdown-w-search-item").filter(function () { return $(this).find(".kdr-dropdown-w-search-item-text").text().trim() == dargs[index].args[i7] })
                                if (a != undefined) {
                                    dargs[index].args[i7] = $(a).data("value")
                                }
                            }
                        } else if ($input.hasClass('kdr-grid-input-file-list')) {
                            let $fileInput = $input.siblings('.kdr-grid-files-input')
                            controls.fileControl.setFiles($fileInput, $(dargs[index].args[i7]))
                            controls.fileControl.refreshUI($fileInput)
                        }
                    })
                    if (dargs[index] != undefined) {
                        controls.setArgs($inputs, dargs[index].args, false)
                    }
                })

                if (editAllP) {
                    hehe.find(".kdr-grid-cancel-all").show().addClass('show')
                    hehe.find(".kdr-grid-save-all").show().addClass('show')
                    hehe.find(".kdr-grid-edit-all").hide().removeClass('show')
                }

                successCallback && successCallback(hehe)
                controls.onGridAfterRenderWInputs(hehe)
            }, selectP, clearP)
        }
    },
    magic: function (endpoint, control, response, $loadingTarget = null, renderOnError = false, selectP = false, successCallback = null) {

        if (response.info != null && (response.renderP != null ? response.renderP : (response.code != gridResponseCodes.ERROR || renderOnError))) {
            if ($(control).hasClass('kdr-control-rerender-w-inputs')) {
                controls.renderWithInputs(endpoint, control, response.info, $loadingTarget, successCallback, selectP)
            } else {
                controls.render(endpoint, control, response.info, $loadingTarget, successCallback, selectP)
            }
        }

        if (response.code == gridResponseCodes.ERROR && response.args.length > 0) {
            $(control).data('mask', response.args[0])
        }

        let messageLabelId = 'message-control-' + control.attr('id')
        $(control).find('#' + messageLabelId).remove()
        let isErrorShown = false

        if (response.message != null && response.message.length != null) {
            let switchOn;
            if (response.args[1] != undefined) {
                switchOn = parseInt(response.args[1])
            } else {
                switchOn = control.data('responseShowType')
            }

            switch (switchOn) {
                case gridActResponseShowTypes.INNER:
                    let styleClasses = 'd-block mb-1 font-weight-bold'

                    switch (response.code) {
                        case gridResponseCodes.SUCCESS:
                            styleClasses += ' kdr-grid-message-success text-success'
                            break
                        case gridResponseCodes.WARNING:
                            styleClasses += ' kdr-grid-message-warning text-warning'
                            break
                        case gridResponseCodes.ERROR:
                            styleClasses += ' kdr-grid-message-error text-danger'
                            break
                        case gridResponseCodes.INFO:
                        default:
                            styleClasses += ' kdr-grid-message-info text-info'
                            break
                    }

                    $('<span/>', {
                        id: messageLabelId,
                        class: styleClasses,
                        html: response.message,
                        style: 'white-space: preserve-breaks;'
                    }).prependTo(control)
                    break
                case gridActResponseShowTypes.TOAST:

                    switch (response.code) {
                        case gridResponseCodes.SUCCESS:
                            toastr.success(response.message)
                            break
                        case gridResponseCodes.WARNING:
                            toastr.warning(response.message)
                            break
                        case gridResponseCodes.ERROR:
                            toastr.error(response.message)
                            break
                        case gridResponseCodes.INFO:
                        default:
                            toastr.info(response.message)
                            break
                    }

                    break
                case gridActResponseShowTypes.MODAL:
                default:
                    let customValues = response.args[2]?.split(';') ?? []
                    let customTitle

                    switch (response.code) {
                        case gridResponseCodes.SUCCESS:
                            customTitle = customValues[0] ?? "~{Success}"
                            modal.getModal.success(customTitle, response.message, true, null, null, null, null, null, $loadingTarget)
                            break
                        case gridResponseCodes.WARNING:
                            customTitle = customValues[0] ?? "~{Warning}"
                            modal.getModal.warning(customTitle, response.message, true, null, null, null, null, null, $loadingTarget)
                            break
                        case gridResponseCodes.ERROR:
                            customTitle = customValues[0] ?? __l.Error
                            modal.getModal.danger(customTitle, response.message, true, null, null, null, null, null, $loadingTarget)
                            break
                        case gridResponseCodes.INFO:
                            customTitle = customValues[0] ?? "~{Info}"
                            modal.getModal.info(customTitle, response.message, true, null, null, null, null, null, $loadingTarget)
                            break
                        case gridResponseCodes.SHOWSPELL:
                            customTitle = customValues[0] ?? "Spell"
                            modal.getModal.showspell(customTitle, response.message, true, null, null, null, null, null, $loadingTarget)
                            break
                        default:
                            modal.getModal.default(customTitle, response.message, true, null, null, null, null, null, $loadingTarget)
                            break
                    }
                    break
            }

            isErrorShown = true
        }

        $(control).data('hasError', isErrorShown)
        controls.onGridAfterMagicError($(control), response.code, null, response.info, response.returnValue, isErrorShown); //fixme wstawic akcje z jakiegos piekla
    },
    onGridBeforeUIInit(grid) {
        grid.trigger({
            type: gridEvents.BEFORE_UI_INIT,
        })
    },
    onGridBeforeRender(grid, code, actionType, info = null, returnValue = null, isErrorShown) {
        grid.trigger({
            type: gridEvents.BEFORE_RENDER,
            code: code,
            actionType: actionType,
            info: info,
            returnValue: returnValue,
            isErrorShown: isErrorShown
        });
    },
    onGridAfterRender(grid, code, actionType) {
        grid.trigger({
            type: gridEvents.AFTER_RENDER,
            code: code,
            actionType: actionType
        });
    },
    onGridAfterRenderImmediately(grid, code, actionType) {
        grid.trigger({
            type: gridEvents.AFTER_RENDER_IMMEDIATELY,
            code: code,
            actionType: actionType
        });
    },
    onGridAfterUiInit($grid) {
        $grid.trigger({
            type: gridEvents.AFTER_UI_INIT,
        });
    },
    onGridAfterFilter(grid) {
        grid.trigger({
            type: gridEvents.AFTER_FILTER,
        });
    },
    onGridAfterRenderWInputs($grid) {
        $grid.trigger({
            type: gridEvents.AFTER_RENDER_W_INPUTS,
        });
    },
    onGridAfterMagicError($grid, code, actionType, info = null, returnValue = null, isErrorShown = false) {
        $grid.trigger({
            type: gridEvents.AFTER_MAGIC_ERROR,
            code: code,
            actionType: actionType,
            info: info,
            returnValue: returnValue,
            isErrorShown: isErrorShown
        });
    },
    onGridAfterCheckAllCheckboxes($grid, columnIndex, checkedP) {
        $grid.trigger({
            type: gridEvents.AFTER_CHECK_ALL_CHECKBOXES,
            columnIndex: columnIndex,
            checkedP: checkedP
        });
    },
    onControlBeforeRender($control, code, actionType, info = null) {
        $control.trigger({
            type: controlEvents.BEFORE_RENDER,
            code: code,
            actionType: actionType,
            info: info,
        });
    },
    onControlAfterRender($control, code, options) {
        $control.trigger({
            type: controlEvents.AFTER_RENDER,
            code: code,
            options: options
        });
    },
    onControlAfterUIInit($control, code) {
        $control.trigger({
            type: controlEvents.AFTER_UI_INIT,
            code: code,
        });
    },
    saveData(fileName, blob) {
        let a = document.createElement("a")
        document.body.appendChild(a);
        $(a).css('display', 'none')


        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
        }
        else {
            let url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
        }

        document.body.removeChild(a);
    },
    s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    },
    fileControl: {
        refreshUI($input) {
            let $files = $($input.prop('files'))
            let filesCount = () => $files.length
            let $previousFiles = controls.fileControl.getFiles($input) //$($input.data('selectedFiles'))

            let $label = $('.kdr-grid-files-input-label[for="' + $input.prop('id') + '"]')
            let $selectedFilesTable = $label.find('.selected-files-table')
            let $selectedFileTemplate = $selectedFilesTable.find('.selected-files-table-row-template')

            function setFiles($f) {
                controls.fileControl.setFiles($input, $f)
            }
            function setSelectedFilesType() {
                let type;
                if (filesCount() == 0) {
                    type = 'none'
                } else if (filesCount() == 1) {
                    type = 'single'
                } else {
                    type = 'multiple'
                }

                $label.find('.selected-files, .selected-files-table').attr('type', type)
            }
            function setSelectedFilesSize() {
                let totalFilesSize = 0
                $($files).each((i, e) => {
                    totalFilesSize += e.size
                });

                let userReadableSize = convert.bytesToUserReadableString(totalFilesSize)
                $label.find('.selected-files-size-value').text(userReadableSize)
            }

            function renderSelectedFile(file) {
                let $row = $($selectedFileTemplate.clone().detach())
                let splittedFileName = file.name.split('.')
                let fileExt = splittedFileName.pop()

                $row.find('.selected-file-name').text(splittedFileName.join(''))
                $row.find('.selected-file-ext').text(fileExt)
                $row.find('.selected-file-size').text(convert.bytesToUserReadableString(file.size))
                $row.removeClass('selected-files-table-row-template')

                $row.find('.selected-file-remove').on('click', (e) => {
                    e.preventDefault()
                    e.stopPropagation()

                    let $newListOfFiles = $files.filter(function (i, e) {
                        return e.id != file.id;
                    });

                    setFiles($newListOfFiles)
                    $files = $newListOfFiles

                    setSelectedFilesSize()
                    setSelectedFilesType()

                    $row.remove()
                })

                $selectedFilesTable.append($row)
            }

            /* SEQUENTIAL ADDING FILES TO INPUT(PROVIDES MULTIPLE INPUT) */
            $files.each((i, e) => e.id = uid.getNew())
            if ($previousFiles) {
                $previousFiles.each(function (i) { $files.push($previousFiles[i]) })
            }
            setFiles($files)


            $selectedFilesTable.find('> *:not(.selected-files-table-row-template)').remove()

            $files.each((i, e) => {
                renderSelectedFile(e)
            });

            setSelectedFilesSize()
            setSelectedFilesType()
        },
        setFiles($input, $files) {
            //const dataTransfer = new DataTransfer();
            //
            //$files.each((i, e) => dataTransfer.items.add(e))
            if ($files.length == 0) {
                $input.val(null)
            }
            $input.data('selectedFiles', $files)
            $input.trigger('fileSet', $files)

        },
        getFiles($input) {
            return $($input.data('selectedFiles'))
        }
    },
    getFiles(controlId) {
        let filesList = []
        let $filesInputs =
            $('#' + controlId + ' .kdr-grid-item-update.show .kdr-grid-files-input,' +
                '#' + controlId + ' .kdr-grid-item-update .kdr-grid-files-input,' +
                '#' + controlId + ' .kdr-grid-key-value .kdr-grid-item-update .kdr-grid-files-input,' +
                '#' + controlId + '.kdr-grid-flip .kdr-grid-files-input,' +
                '#copied-grid-edit-modal-' + controlId + '.kdr-grid-modal-item-update.show .kdr-grid-files-input,' +
                '#copied-grid-add-modal-' + controlId + '.kdr-grid-item-insert .kdr-grid-files-input,' +
                '#' + controlId + ' .kdr-grid-files-input')

        //take all files
        $filesInputs.each(function (index) {
            let $input = $filesInputs.eq(index)

            //let fl = $input.data('selectedFiles')
            //let fl = $input.prop('files')
            let fl = controls.fileControl.getFiles($input)// jak ktos to bedzie zmienial to niech powie dlaczego CL

            if (!fl) {
                fl = [];
            }

            for (let i = 0; i < fl.length; i++) {
                if ($input.closest('td').data('language') == undefined) {
                    filesList.push({ index: $input.data('index'), file: fl[i] })
                }
                else {
                    filesList.push({ index: $input.data('index') + '-' + $input.closest('td').data('language'), file: fl[i] })
                }
            }
        })

        return filesList
    },
    getMultipleFiles(controlId) {
        let filesList = []

        //take all files
        //$('#' + controlId + ' .kdr-grid-item-update td').each(function () {
        $('#' + controlId + ' .kdr-grid-item-update > td[data-item-ordinal] .kdr-grid-files-input').each(function () {
            /*let $td = $(this)*/
            /*$td.find('').each(function () {*/
            let $input = $(this)
            //let fl = $input.prop('files')
            let fl = controls.fileControl.getFiles($input)// jak ktos to bedzie zmienial to niech powie dlaczego CL

            if (!fl) {
                fl = [];
            }

            for (let i = 0; i < fl.length; i++) {
                filesList.push({ row: $input.closest('[data-row-index]').data('rowIndex'), index: $input.data('index'), file: fl[i] })
            }
            /*})*/
        })

        return filesList
    },
    appendFilesToFormData(formData, files, $control, checkForControlUploadLimit = true, multiMode = false) {
        if (files != undefined && files.length > 0) {
            let maxUploadSize = controls.getMaxUploadSize($control)
            let totalFilesSize = files.map((x, y) => x.file.size).reduce(function (p, c, i, a) {
                return p + c;
            });

            if (checkForControlUploadLimit === true && maxUploadSize != undefined && totalFilesSize > maxUploadSize) {
                let maxUploadUserReadable = convert.bytesToUserReadableString(maxUploadSize)
                modal.getModal.warning("~{Warning}",
                    `~{Limit for single upload of newly added files is: !{<span class="font-weight-medium">${maxUploadUserReadable}</span>}}.\n\t~{Remove some new files and try again.}`)
                return false
            }

            for (let i = 0; i < files.length; i++) {
                formData.append(true == multiMode ? files[i].row + '|' + files[i].index : files[i].index, files[i].file, files[i].file.name)
            }
        }
    },
    /**
     * Displaying selected items by kdr-grid-files selector under the selector as kafle
     * @param {any} $input File input
     */
    renderSelectedItems($input) {
        let $this = $input
        let files = $this.prop('files')
        let $files = $(files)
        let isMultiple = $this.attr('multiple') ? true : false
        let $template = isMultiple
            ? $this.closest('.kdr-grid-files').find('.template .kdr-grid-files-file').clone().detach()
            : $this.closest('.kdr-grid-files').find('.template .kdr-grid-single-file').clone().detach()
        let readyTemplates = []
        let previousFiles = $this.data('selectedFiles')
        let allFiles = []
        let $progessBar = $this.closest('.kdr-grid-files').find('.kdr-grid-files-weight_bar')
        let maxFilesWeight = $progessBar.attr('aria-valuemax')
        let filesWeight = 0
        let displayfilesWeight = ''

        /*If signle mode ten remove files from view*/
        if (isMultiple == false) {
            $this.closest('.kdr-grid-files').find('.kdr-grid-files-list').html('')
        }

        /*RENDERING FILES*/
        $files.each(function (index) {
            let $thisTemplate = $template.clone()
            let $item = $files[index]
            let displayName = $item.name
            let displaySize = convert.bytesToUserReadableString($item.size)
            if (isMultiple && displayName.length > 30) {
                displayName = $item.name.substring(0, 30) + '...'
            }

            $item.id = uid.getNew()

            $thisTemplate.find('.file-name_label')[0].innerHTML = displayName
            if (isMultiple) {
                $thisTemplate.find('.file-size_label')[0].innerHTML = '(' + displaySize + ')'
            }
            $thisTemplate.find('.file-id').val($item.id)

            readyTemplates.push($thisTemplate)

            allFiles.push($item)
        })
        $this.closest('.kdr-grid-files').find('.kdr-grid-files-list').append(readyTemplates)

        /*SEQUENTIAL ADDING FILES TO INPUT(PROVIDES MULTIPLE INPUT)*/
        if (previousFiles) {
            $(previousFiles).each(function (index) { allFiles.push(previousFiles[index]) })
        }
        $this.data('selectedFiles', allFiles)

        /*SETTING PROGRESS OF FILES WEIGHT*/
        $(allFiles).each(function (index, element) {
            filesWeight += element.size
        })

        $this.closest('.kdr-grid-files').find('.kdr-grid-files-weight_info-value').text(convert.bytesToUserReadableString(filesWeight))

        let progressBarWidth = parseInt(((filesWeight / maxFilesWeight) * 100) + 0.5, 10)

        if (progressBarWidth > 100) {
            progressBarWidth = 100
            $progessBar.addClass('bg-danger')
        } else {
            $progessBar.removeClass('bg-danger')
        }

        $progessBar.css('width', progressBarWidth + '%')
        $this.val('')

        /*DISABLING/ENABLING INPUT*/
        //if (!isMultiple && allFiles.length >= 1) {
        //    $this.attr('disabled', true)
        //    $this.parent().attr('disabled', true)
        //} else {
        //    $this.attr('disabled', false)
        //    $this.parent().removeAttr('disabled', true)
        //}

        if (filesWeight > $this.attr('max-weight')) {
            let error = ""

            if (allFiles.length > 1) {
                error = "Files size is too big."
            } else {
                error = "File size is too big."
            }

            modal.getModal.danger(__l.Error, r, true)
        }
    },
    /**
     * Returns $control from document  
     * @param {any} controlId Grid ID
     * @param {any} $element Element in modal if grid is displaying in grid, 
     * better base on control id if theres more then one grid on modal.
     */
    getControl(controlId = undefined, $element = undefined) {
        if (controlId != undefined && controlId != null && controlId.length > 0) {
            return $('#' + controlId)
        } else if ($element != undefined && $element != null) {

            let $g = $element.closest('.kdr-grid')
            let $modal = $element.closest('.modal')

            //let $grid = $element.closest('.modal').find('.kdr-grid') //to jest straszne

            if ($g.length > 0) {
                return $g
            }
            else if ($modal.length > 0) {
                return $modal.find('.kdr-grid')                        //to jest okropne
            } else {
                console.error('controls.getControl - Cannot find grid.')
            }
        } else {
            console.error('controls.getControl - You need to pass at least one selector.')
            return
        }
    },
    organizeElementListsInTinyMCE($content) {
        let $clonedContent = $content.clone()
        let $elementsList = $clonedContent.find('.marker-section')
        if ($elementsList.length > 0) {
            for (var i = 0; i < $elementsList.length; i++) {
                let $element = $elementsList.eq(i)
                let isOdd = i & 1
                $element.addClass(isOdd ? "marker-section-stop" : "marker-section-start")
                $element.removeClass(!isOdd ? "marker-section-stop" : "marker-section-start")
            }

            let htmlContent = $('<div>').append($clonedContent).prop('innerHTML')
            return htmlContent
        } else
            return null
    },
    prepareTinyMCE(control) {
        let $control = $(control)
        var wordClipboardP = false
        var pasteHtml = ''


        $control.find('[id*="kdr-grid-editor"]:not(.ignore-grid-tinymce-init)').each(function (i, e) {
            let $editor = $(e)
            let id = $editor.prop('id')
            let isHideToolbar = $editor.hasClass('tinymce-hide-toolbar')
            let isSmollStartHeight = $editor.hasClass('tinymce-smoll-height')
            let arePrimitiveMenuOptions = $editor.hasClass('tinymce-primitive-toolbar')
            let minaturalizeImages = $editor.hasClass('minaturalize-images')
            let ignoreImages = $editor.hasClass('tinymce-ignore-image-handler')
            let imageCarousel = false //$editor.hasClass('tinymce-image-carousel')
            let isLegacyTinyMce = $editor.hasClass('kdr-grid-input-tinymc-wrapper')

            let height = isHideToolbar
                ? parseInt($editor.css('line-height')) + parseInt($editor.css('font-size'))
                : isSmollStartHeight
                    ? '8rem'
                    : Math.round(window.outerHeight * 0.35)

            if (height == 0) {
                height = 400
            }

            let additionalCss = isHideToolbar ? `body { min-height: ${height}; max-height: ${height}; overflow-y: hidden}`
                /*: arePrimitiveMenuOptions ? `:root {font-size: ${thisFontSize} !important; }`*/
                : '';

            additionalCss += 'html body {min-height: auto; overflow: auto !important;}'

            additionalCss += minaturalizeImages ? 'img {height:10rem}' : '';

            let isPDFEditor = $editor.hasClass('tinymce-pdf')
            let isPtFontSize = $editor.hasClass('tinymce-pt-font-size')
            let variablePlugins = isPDFEditor ? 'ruler' : ''
            variablePlugins += ignoreImages ? '' : ' image media'
            variablePlugins += imageCarousel ? ' carousel' : ''

            let thisFontSize = Math.round($editor.css('font-size').replace('px', '')) /*+ 1*/ /*+ 'px'*/
            if (isPtFontSize) {
                thisFontSize = 12;
            }

            let fontSizesNumbers = [4, 6, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 26, 27, 28, 30, 34, 36, thisFontSize]
            fontSizesNumbers = arrayHelper.unique(fontSizesNumbers)
            fontSizesNumbers = arrayHelper.sortNumbers(fontSizesNumbers)
            let fontSizes = isHideToolbar ? thisFontSize + 'px' : fontSizesNumbers.map(x => x + ((isPDFEditor || isPtFontSize) ? 'pt' : 'px')).join(' ')


            tinyMCE.execCommand("mceRemoveEditor", true, id)

            let $content = $($.parseHTML($editor.valExtended()))
            let htmlContent = controls.organizeElementListsInTinyMCE($content)
            if (htmlContent != null) {
                $editor.val(htmlContent)
            }

            tinymce.init({
                menubar: !(isHideToolbar || arePrimitiveMenuOptions),
                ...(!isLegacyTinyMce && {
                    menu: {
                        file: { title: 'File', items: 'newdocument restoredraft | preview | print' },
                        edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace' },
                        view: { title: 'View', items: 'code suggestededits revisionhistory | visualaid visualchars visualblocks | preview fullscreen' },
                        insert: { title: 'Insert', items: 'charmap emoticons hr | insertdatetime' },
                        format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | styles fontfamily fontsize lineheight | forecolor | removeformat' },
                        tools: { title: 'Tools', items: ' code ' },
                    }
                }),
                statusbar: false,
                selector: '#' + id,
                paste_data_images: true,
                toolbar_sticky: true,
                paste_as_text: false,
                height: height,
                body_class: `editor-content dropzone ${isHideToolbar ? 'goddamn' : ''}`,
                plugins: isLegacyTinyMce ? [
                    'advlist autolink lists link charmap print preview anchor',
                    'searchreplace visualblocks code noneditable',
                    'insertdatetime table paste emoticons ',
                    variablePlugins
                ] : [
                    'advlist autolink lists link charmap print preview',
                    'searchreplace visualblocks code noneditable',
                    'insertdatetime paste emoticons',
                    variablePlugins
                ],
                ruler: isPDFEditor,
                relative_urls: false,
                remove_script_host: false,
                convert_urls: false,
                toolbar: isHideToolbar
                    ? false : isLegacyTinyMce ? arePrimitiveMenuOptions
                        ? `forecolor backcolor | fontsizeselect | bold italic underline strikethrough | bullist numlist | code`
                        : `insertfile undo redo | fontsizeselect | fontselect
                      | styleselect | forecolor backcolor | bold italic
                      | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent
                      | link image | media ${isPDFEditor ? '| ruler' : ''} | ${$editor.hasClass('tinymce-image-carousel') ? '| carousel' : ''}`
                        : arePrimitiveMenuOptions
                            ? `forecolor | fontsizeselect | bold italic underline strikethrough | bullist numlist`
                            : `insertfile undo redo | fontsizeselect | fontselect | forecolor | bold italic 
                           | bullist numlist | ${isPDFEditor ? '| ruler' : ''}`,
                content_css: [
                    __root + 'core/css/core.min.css?v=' + uid.getNew(),
                    __root + 'app/css/site.min.css?v=' + uid.getNew(),
                    __root + `app/css/theme.${__themeName}.css?v=` + uid.getNew(),
                    __root + `core/lib/fontawesome-pro-6.1.1-web/css/all.min.css?v=` + uid.getNew(),
                ],
                content_style: `${additionalCss} body {font-size: ${thisFontSize}${(isPDFEditor || isPtFontSize) ? 'pt' : 'px'}; }`,
                font_formats:
                    "Aptos Body=Aptos Body,Tahoma,Arial,sans-serif;" +
                    "Calibri=Calibri,Arial,sans-serif;" +
                    "Arial=Arial,Helvetica,sans-serif;" +
                    "Andale Mono=andale mono,times;" +
                    "Arial Black=arial black,avant garde;" +
                    "Book Antiqua=book antiqua,palatino;" +
                    "Comic Sans MS=comic sans ms,sans-serif;" +
                    "Courier New=courier new,courier;" +
                    "Georgia=georgia,palatino;" +
                    "Tahoma=tahoma,arial,helvetica,sans-serif;" +
                    "Times New Roman=times new roman,times;" +
                    "Trebuchet MS=trebuchet ms,geneva;" +
                    "Verdana=verdana,geneva;",
                fontsize_formats: fontSizes,
                extended_valid_elements: 'marker,b/strong,i/em/span[*],ul[class|style],ol[type|class|style|start],li[class|style]',
                force_p_newlines: false,
                file_picker_types: 'image',
                automatic_uploads: true,
                forced_root_block: isLegacyTinyMce ? 'p' : false,
                file_picker_callback: function (cb, value, meta) {
                    var input = document.createElement('input');
                    input.setAttribute('type', 'file');
                    input.setAttribute('accept', 'image/*');

                    input.onchange = function () {
                        var file = this.files[0];

                        var reader = new FileReader();
                        reader.onload = function () {
                            var id = 'blobid' + (new Date()).getTime();
                            var blobCache = tinyMCE.activeEditor.editorUpload.blobCache;
                            var base64 = reader.result.split(',')[1];
                            var blobInfo = blobCache.create(id, file, base64);
                            blobCache.add(blobInfo);

                            cb(blobInfo.blobUri(), { title: file.name });
                        };
                        reader.readAsDataURL(file);
                    };

                    input.click();
                },

                entity_encoding: "raw",
                // Tells Tinymce to treat any content with [] around it as noneditable
                noneditable_regexp: [/\[[^\[\]]*\]/g],
                paste_preprocess: function (plugin, args) {
                    var clipboardData = args.content;
                    var html = pasteHtml == '' ? args.content : pasteHtml;

                    pasteHtml = '';

                    html = html.replace(/\[\d+(?:,\d+)*\]/g, '');
                    html = html.replace(/"\d{6,}":"[^"]*",?/g, '');
                    html = html.replace(/\s(data|aria)-[a-zA-Z0-9\-]+="[^"]*"/g, '');
                    html = html.replace(/\u00A0/g, ' ');

                    // Sprawdzanie, czy wklejane dane są linkiem
                    if (/^https?:\/\/\S+$/.test(clipboardData)) {
                        // Jeśli dane to link, wstaw go jako aktywny link HTML
                        html = '<a href="' + clipboardData + '">' + clipboardData + '</a>';
                    }
                    else if (ignoreImages == true && clipboardData.includes('<img')) {
                        html = ''
                        toastr.warning(__l.CannotPasteImage)
                    }

                    args.content = html;
                },
                media_url_resolver: function (data, resolve /*, reject */) {

                    const shortsMatch = data.url.match(
                        /^https?:\/\/(www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/
                    );

                    if (shortsMatch) {
                        const videoId = shortsMatch[2];

                        resolve({
                            html:
                                '<iframe ' +
                                'src="https://www.youtube.com/embed/' + videoId + '" ' +
                                'width="560" height="315" ' +
                                'frameborder="0" ' +
                                'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" ' +
                                'allowfullscreen>' +
                                '</iframe>'
                        });

                        return;
                    }

                    resolve({ html: '' });
                },
                setup: function (editor) {
                    var $ = tinymce.dom.DomQuery;
                    var nonEditableClass = editor.getParam('noneditable_noneditable_class', 'mceNonEditable');

                    editor.on('keydown', function (evt) {
                        if (evt.keyCode == 9) {
                            editor.execCommand("mceInsertContent", false, "  ");
                            tinymce.dom.Event.cancel(evt);
                            return;
                        }
                    });
                    // Register a event before certain commands run that will turn contenteditable off temporarilly on noneditable fields
                    editor.on('BeforeExecCommand', function (e) {
                        // The commands we want to permit formatting noneditable items for
                        var textFormatCommands = [
                            'mceToggleFormat',
                            'mceApplyTextcolor',
                            'mceRemoveTextcolor',
                        ];
                        if (textFormatCommands.indexOf(e.command) !== -1) {
                            $(editor.getBody()).find('.' + nonEditableClass).attr('contenteditable', null);
                        }
                    });
                    editor.on('ExecCommand', function (e) {
                        if (e.command != 'mceRulerRecalculate') {

                            let $currentBody = $(editor.getBody())

                            $currentBody.find('.' + nonEditableClass).attr('contenteditable', false);
                            let htmlContent = controls.organizeElementListsInTinyMCE($currentBody)
                            if (htmlContent != null) {
                                editor.setContent(htmlContent)
                            }
                        }
                    });
                    let args = [];
                    let lang = $editor.closest('.tiny-mce-container').data('language')

                    let editorIndex = $editor.data('index')
                    editor.on('input change', function () {
                        controls.getArgs([$editor], args)
                        let v = lang == undefined ? args[editorIndex] : args[editorIndex][lang]
                        $editor.val(v).trigger('input')
                    })

                    editor.on('paste', function (e) {

                        controls.getArgs([$editor], args)
                        const clipboard = e.clipboardData
                        var html = e.clipboardData.getData('text/html');

                        if (ignoreImages == true && (html.includes('<img') || (clipboard.files && clipboard.files.length > 0))) {
                            toastr.warning(__l.CannotPasteImage)
                            return;
                        }

                        if (clipboard.files && clipboard.files.length > 0) {
                            e.preventDefault(); // przejmujemy wklejanie obrazka

                            const file = clipboard.files[0];
                            if (!file.type.startsWith('image/')) {
                                return;
                            }

                            const reader = new FileReader();
                            reader.onload = function () {
                                const id = 'pasteblob' + (new Date()).getTime();
                                const blobCache = tinymce.activeEditor.editorUpload.blobCache;
                                const base64 = reader.result.split(',')[1];
                                const blobInfo = blobCache.create(id, file, base64);
                                blobCache.add(blobInfo);

                                // wstawiamy obraz do edytora w miejscu kursora
                                editor.insertContent('<img src="' + blobInfo.blobUri() + '" />');
                            };
                            reader.readAsDataURL(file);

                            return; // dalej nie obrabiamy HTML
                        }

                        if (!clipboard || html == '') {
                            return;
                        }

                        const start = html.indexOf('<!--StartFragment-->');
                        const end = html.indexOf('<!--EndFragment-->');

                        if (start !== -1 && end !== -1 && end > start) {
                            html = html.substring(start + '<!--StartFragment-->'.length, end);
                        }

                        html = convertWordFakeListsToUl(html);

                        wordClipboardP = /class="?Mso|style="[^"]*mso-|<o:p>|<!--\[if|<!\[endif]|<v:shape|mso-list:/i.test(html);;

                        html = html.replace(/<!\[if !vml]>/gi, '');
                        html = html.replace(/<!\[endif]>/gi, '');
                        html = html.replace(/ class="Mso[^"]*"/gi, '');
                        html = html.replace(/<meta[^>]*>/gi, '');
                        html = html.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

                        html = html.replace(
                            /<a([^>]*\sname="OLE_LINK\d+"[^>]*)>([\s\S]*?)<\/a>/gi,
                            '$2'
                        );

                        html = html.replace(
                            /<img\b[^>]*\bsrc\s*=\s*(?:"file:\/\/\/[^"]*"|'file:\/\/\/[^']*'|file:\/\/\/\S+)[^>]*>/gi,
                            '<p style="margin: 12px 0; font-weight: bold; font-style: italic;">[OBRAZEK Z WORDA – WSTAW RĘCZNIE]</p>'
                        );

                        // VML v:imagedata 
                        html = html.replace(
                            /<v:shape\b[^>]*>\s*<v:imagedata\b[^>]*>\s*<\/v:shape>/gi,
                            '<p style="margin: 12px 0; font-weight: bold; font-style: italic;">[OBRAZEK Z WORDA – WSTAW RĘCZNIE]</p>'
                        );

                        // alternatywnie sam v:imagedata
                        html = html.replace(
                            /<v:imagedata\b[^>]*src\s*=\s*["']?(?:file:\/\/\/|wordml:\/\/)[^"'>\s]+["']?[^>]*>/gi,
                            '<p style="margin: 12px 0; font-weight: bold; font-style: italic;">[OBRAZEK Z WORDA – WSTAW RĘCZNIE]</p>'
                        );

                        html = html.replace(
                            /\bmso-bookmark:[^;'""]*;?/gi,
                            ''
                        );
                        html = html.replace(
                            /<a\b[^>]*\bname\s*=\s*["']_Hlk[^"']*["'][^>]*>([\s\S]*?)<\/a>/gi,
                            '$1'
                        );


                        pasteHtml = html

                        //editor.setContent(html)
                    })
                },
                init_instance_callback: function (editor) {
                    /* 
                    The following two hacks fix some weirdness with the way the textcolor
                    plugin works - namely, it was attemping to apply color and background-color
                    directly on the element that had the noneditable css class on it instead of putting
                    a span around it as underline does.
                    */
                    editor.formatter.get('forecolor')[0].exact = true;
                    editor.formatter.get('hilitecolor')[0].exact = true;
                }
            })
            $(document).off('focusin.modal')
        })
    },
    getInputs($control) {
        if ($control.hasClass('kdr-frax-self-existing')) {
            return $control.find('.kdr-frax--tree')
        } else if ($control.hasClass('kdr-filters-tabs')) {
            return $control.find('a.active')
        } else if ($control.hasClass("kdr-kanban") || $control.hasClass('kdr-frax-folder') || $control.hasClass('kdr-form-steps')) {
            return $control
        } else {
            return $control.find(".kdr-filters-input")
        }
    },
    getCommands($control) {
        return JSON.parse($control.find('.kdr-commands').eq(0).val())
    },
    getEndpoint($control) {
        if ($control.hasClass("kdr-filters")) {
            return 'Filters/Render';
        } else if ($control.hasClass("kdr-frax") || $control.hasClass("kdr-frax-folder")) {
            return 'Frax/Render';
        } else if ($control.hasClass("kdr-filters-tabs")) {
            return 'Filters/RenderTabs';
        } else if ($control.hasClass("kdr-matrix")) {
            return 'kdr-matrix';
        } else if ($control.hasClass("kdr-kanban")) {
            controls.onGridBeforeRender($control, gridResponseCodes.SUCCESS, null);
            return 'Kanban/Render';
        } else if ($control.hasClass("kdr-incell")) {
            return 'InCell/Render';
        } else if ($control.hasClass("kdr-tile-selection")) {
            return 'TileSelectionList/Render';
        } else if ($control.hasClass("kdr-fancy-tile")) {
            return 'FancyTile/Render';
        } else if ($control.hasClass("kdr-questions")) {
            return 'Questions/Render';
        } else if ($control.hasClass("survey-new-order")) {
            return 'SurveyNewOrder/Render';
        } else if ($control.hasClass("modular-tile")) {
            return 'ModularTile/Render';
        } else if ($control.hasClass("tile-placeholder")) {
            //endpoint, który ma zignorować render z filtra
            return 'IgnoreFilter';
        } else if ($control.hasClass("kdr-bullet-list")) {
            return 'BulletList/Render';
        } else if ($control.hasClass("kdr-form-edit")) {
            controls.onControlBeforeRender($control, gridResponseCodes.SUCCESS, null);
            return 'FormEdit/Render';
        } else if ($control.hasClass("kdr-form-steps")) {
            return 'FormSteps/Render';
        } else if ($control.hasClass("kdr-form-preview-wrapper")) {
            return 'FormPreview/Render';
        } else if ($control.hasClass("kdr-form-dictionary-matrix")) {
            return 'FormDictionaryMatrix/Render';
        } else if ($control.hasClass("course-chapter-creator")) {
            return 'CourseChapterCreator/Render'
        } else if ($control.hasClass("course-section-creator")) {
            return 'CourseSectionCreator/Render'
        } else if ($control.hasClass("kdr-knowledge-base-user-tiles")) {
            return 'KnowledgeBaseUserTiles/Render';
        } else if ($control.hasClass("kdr-article-preview")) {
            return 'ArticlePreview/Render'
        } else if ($control.hasClass("kdr-events-calendar")) {
            return 'EventsCalendar/Render'
        } else if ($control.hasClass("kdr-dynamic-filters")) {
            return 'DynamicFilters/Render'
        } else {
            return 'Grid/Render';
        }
    },
    relationActions: {
        0: function (command, callback) {
            if (callback != null) {
                callback()
            }
        },
        1: function (command, callback) {
            let $target = $('#' + command.Target)
            //let endpoint = $target.hasClass("kdr-filters") ? 'Filters/Render' : 'Grid/Render'; //fixme do metody jakies
            let endpoint = controls.getEndpoint($target);

            //Plomba cygana burego
            if (endpoint == 'kdr-matrix') { //no nie wiem troche plomba ale z zdrugiej strony matrycy nie mozna po prostu zrobic render wiec taki mały kompromis chlip chlip. czyli mamy czeski remis kiedy turek próbuje okrasc cygana niby z czego?
                $target.trigger({
                    type: "MATRIX_UPDATE",
                    clearLeftFiltersP: true
                });
            } else {
                controls.render(endpoint, $target, controls.getInfo($target), undefined, callback)
            }
        },
        2: function (command, callback) {
            let $filter = $('#' + command.Source)
            let $target = $('#' + command.Target)
            let $t = [] //$.merge($filter, $target)


            function addLoadingElement($element) {
                let $elementToAdd = null

                if ($element.closest('.modal-content').length > 0) {
                    $elementToAdd = $element.closest('.modal-content')
                }
                else if ($element.closest('.tilemenu-row').length > 0) {
                    $elementToAdd = $element.closest('.tilemenu-row')
                } else {
                    $elementToAdd = $element
                }

                $t = $.merge($t, $elementToAdd)
            }

            addLoadingElement($filter)
            addLoadingElement($target)
            $t = $.unique($t)

            //let inputs = $filter.find(".kdr-filters-input")
            let inputs = controls.getInputs($filter)
            let args = {}
            controls.getArgs(inputs, args)

            $.ajax({
                type: "POST",
                url: __root + "Filters/Change",
                datatype: "json",
                traditional: true,
                data: {
                    "info": controls.getInfo($filter),
                    "args": JSON.stringify(args)
                },
                success: function (response) {
                    controls.setInfo($filter, response.info)

                    $.ajax({
                        type: "POST",
                        url: __root + "Filters/AdvancedFilter",
                        datatype: "json",
                        traditional: true,
                        data: {
                            "control": controls.getInfo($target), // $target.find(".kdr-info").val(),
                            "filters": controls.getInfo($filter), // $filter.find(".kdr-info").val(),
                            "args": JSON.stringify(args)
                        },
                        success: function (response) {
                            controls.setInfo($target, response.info)
                            controls.onGridAfterFilter($target)

                            if (callback != null) {
                                callback()
                            }
                        },
                        beforeSend: function () {
                            loading.show($t)
                        },
                        complete: function () {
                            loading.hide($t)
                        }
                    })
                },
                beforeSend: function () {
                    loading.show($t)
                },
                complete: function () {
                    loading.hide($t)
                }
            })
        },
        4: function (command, callback) {
            let $target = $('#' + command.Target)
            let endpoint = controls.getEndpoint($target);

            controls.renderWithInputs(endpoint, $target, controls.getInfo($target), undefined, callback)
        },
        8: function (command, callback) {
            let $filter = $('#' + command.Source)
            let $target = $('#' + command.Target)
            let $t = [] //$.merge($filter, $target)


            function addLoadingElement($element) {
                let $elementToAdd = null

                if ($element.closest('.modal-content').length > 0) {
                    $elementToAdd = $element.closest('.modal-content')
                }
                else if ($element.closest('.tilemenu-row').length > 0) {
                    $elementToAdd = $element.closest('.tilemenu-row')
                } else {
                    $elementToAdd = $element
                }

                $t = $.merge($t, $elementToAdd)
            }

            addLoadingElement($filter)
            addLoadingElement($target)
            $t = $.unique($t)

            //let inputs = $filter.find(".kdr-filters-input")
            let inputs = controls.getInputs($filter)
            let args = {}
            controls.getArgs(inputs, args)

            $.ajax({
                type: "POST",
                url: __root + "Filters/Change",
                datatype: "json",
                traditional: true,
                data: {
                    "info": controls.getInfo($filter),
                    "args": JSON.stringify(args)
                },
                success: function (response) {
                    controls.setInfo($filter, response.info)

                    $.ajax({
                        type: "POST",
                        url: __root + "Filters/AdvancedFilter",
                        datatype: "json",
                        traditional: true,
                        data: {
                            "control": controls.getInfo($target), // $target.find(".kdr-info").val(),
                            "filters": controls.getInfo($filter), // $filter.find(".kdr-info").val(),
                            "args": JSON.stringify(args),
                            "refilterP": true
                        },
                        success: function (response) {
                            controls.setInfo($target, response.info)
                            controls.onGridAfterFilter($target)

                            if (callback != null) {
                                callback()
                            }
                        },
                        beforeSend: function () {
                            loading.show($t)
                        },
                        complete: function () {
                            loading.hide($t)
                        }
                    })
                },
                beforeSend: function () {
                    loading.show($t)
                },
                complete: function () {
                    loading.hide($t)
                }
            })
        },
    },
    parseCommands(commands) {

        let command = commands[0]
        if (command == undefined) {
            return;
        }

        $('#' + command.Source).trigger(controlEvents.BEFORE_PARSE_COMMAND)

        //console.log(`Starting action: ${command.Action}:\r\nTarget: ${command.Target}`)
        controls.relationActions[command.Action](command, function () {
            //console.log(`Ended action: ${command.Action}:\r\nTarget: ${command.Target}`)
            let cmds = commands.slice(1);
            controls.parseCommands(cmds)
        })

        //nie usuwac
        //let grouppedCommands = commands
        //    .sort((a, b) => a.Level - b.Level)
        //    .reduce((acc, item) => {
        //        if (!acc[item.Level]) {
        //            acc[item.Level] = [];
        //        }
        //        acc[item.Level].push(item);
        //        return acc;
        //    }, {});

        //for (var level in grouppedCommands) {
        //    let group = grouppedCommands[level]

        //    for (var i = 0; i < group.length; i++) {
        //        controls.relationActions[command.Action](command, function () {
        //            let cmds = commands.slice(1);
        //            controls.parseCommands(cmds)
        //        })
        //    }
        //}
    },
    invokeCommands($control) {
        let commands = controls.getCommands($control)

        controls.parseCommands(commands)
    },
    legacyFilter($control, $filter, args) {

        $.ajax({
            type: "POST",
            url: __root + "Filters/Filter",
            datatype: "json",
            traditional: true,
            data: {
                "control": controls.getInfo($control),
                "filters": controls.getInfo($filter),
                "args": JSON.stringify(args)
            },
            success: function (response) {
                controls.magic("Grid/Render", $control, response)
            },
            beforeSend: function () {
                loading.show($controls)
            },
            complete: function () {
                loading.hide($control)
            }
        })
    },
    tabFilter($that) {
        let $tabs = $that.closest(".kdr-filters-tabs")

        controls.invokeCommands($tabs)

        let inputs = controls.getInputs($tabs)
        let $loadingTarget = $that.closest('.tilemenu-row')

        if (0 === $loadingTarget.length) {
            $loadingTarget = $tabs
        }

        controls.filtersChange($tabs, (r) => controls.magic("Filters/RenderTabs", $tabs, r, $loadingTarget))
    },
    filter($that) {
        let $filters = $that.closest(".kdr-filters")
        //$filters = $that.closest(".kdr-filters")

        controls.filtersChange($filters, (response) => {
            let filtersId = '#' + $filters.prop('id')
            $(document).one(gridEvents.AFTER_RENDER, filtersId, function () {
                controls.invokeCommands($filters)
            })

            controls.magic("Filters/Render", $filters, response)
        })
    },
    filterKanban($that, showLoadingOnInitiator = false) {
        let $filters = $that.closest(".kdr-kanban")

        controls.filtersChange($filters, (response) => {

            controls.getInfo($filters)
            controls.setInfo($filters, response.info)

            $filters.trigger('kanban-end-rendered')
        })
    },
    filtersClick() {
        let $filters = $('#project-filters')

        if ($filters.length > 0) {
            controls.refresh($filters)
            let $filterBtn = $('#project-filters').find('.kdr-filters-btn').click()
        }
    },
    filtersChange($filtersContainer, callbackOnSuccess, $loadingTarget) {

        if ($filtersContainer.hasClass('kdr-filters') === false &&
            $filtersContainer.hasClass('kdr-filters-tabs') === false &&
            $filtersContainer.hasClass('kdr-frax') === false &&
            $filtersContainer.hasClass('kdr-frax-folder') === false &&
            $filtersContainer.hasClass('kdr-kanban') === false &&
            $filtersContainer.hasClass('kdr-form-steps') === false &&
            $filtersContainer.hasClass('kdr-events-calendar') === false) {
            $filtersContainer = $filtersContainer.closest(".kdr-filters")
        }

        if ($loadingTarget == undefined) {
            $loadingTarget = $filtersContainer
        }

        let inputs = controls.getInputs($filtersContainer)
        let args = {}
        controls.getArgs(inputs, args)

        $.ajax({
            type: "POST",
            url: __root + "Filters/Change",
            datatype: "json",
            traditional: true,
            data: {
                "info": controls.getInfo($filtersContainer),
                "args": JSON.stringify(args)
            },
            success: function (response) {
                callbackOnSuccess && callbackOnSuccess(response)
            },
            beforeSend: function () {
                loading.show($loadingTarget)
            },
            complete: function () {
                loading.hide($loadingTarget)
            }
        })
    },
    clear($this) {
        let $filters = $this.closest(".kdr-filters")


        let info = controls.getInfo($filters)//$filters.find(".kdr-info").val()

        $.ajax({
            type: "POST",
            url: __root + "Filters/Render",
            datatype: "json",
            traditional: true,
            data: {
                "info": info,
                "clearP": true
            },
            success: function (response) {
                let $r = $(response)
                $filters.replaceWith($r)
                //let inputs = $r.find(".kdr-filters-input")

                let id = "#" + $r.attr("data-control-id")
                if (id != '#') {
                    let control = $(id)
                    let inputs = controls.getInputs($r)
                    let args = {}
                    controls.getArgs(inputs, args)

                    $.ajax({
                        type: "POST",
                        url: __root + "Filters/Filter",
                        datatype: "json",
                        traditional: true,
                        data: {
                            "control": controls.getInfo(control),// control.find(".kdr-info").val(),
                            "filters": controls.getInfo($r),// $r.find(".kdr-info").val(),
                            "args": JSON.stringify(args)
                        },
                        success: function (response) {
                            controls.magic("Grid/Render", control, response, $filters)
                        }
                    })
                } else {
                    controls.invokeCommands($r)
                }
            },
            beforeSend: function () {
                loading.show($filters)
            },
            complete: function () {
                loading.hide($filters)
            },
        })
    },
    parseDownloadFileResponse(response, textStatus, request, getMimeTypeFromRequestP = true, previewP) {
        let mimeType = getMimeTypeFromRequestP ? (request.getResponseHeader('content-type') ?? 'application/octet-stream') : 'application/octet-stream'

        if (['video/mp4', 'video/webm', 'image/jpeg', 'image/png', 'application/pdf'].includes(mimeType)) {
            previewP = true /* przegladarka umie to wyswietlic */
        }

        let blob = new Blob([response], { type: mimeType });
        let url = window.URL || window.webkitURL;

        var a = $("<a />");
        if (previewP) {
            a.attr("target", "_blank")
        }
        else {
            let fileName = request.getResponseHeader('Content-Disposition').match(`filename=(.*);`)[1].replace(`"`, '').replace(`"`, '');
            a.attr("download", fileName);
        }
        a.attr("href", url.createObjectURL(blob));
        $("body").append(a);
        a[0].click();
        /*$("body").remove(a);*/
    },
    downloadGridFile(info, magic, columnIndex, itemIndex, $loadingTarget = null, previewP) {
        $.ajax({
            type: "POST",
            url: window.location.origin + __root + 'Grid/GridDownLoadFile',
            xhr: function () {
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 2) {
                        if (xhr.status == 500) {
                            xhr.responseType = "text";
                        } else {
                            xhr.responseType = "blob";
                        }
                    }
                };
                return xhr;
            },
            traditional: true,
            data: {
                info: info,
                magic: magic,
                columnIndex: columnIndex,
                itemIndex: itemIndex,
            },
            success: function (response, textStatus, request) {
                controls.parseDownloadFileResponse(response, textStatus, request, true, previewP)
            },
            error: function (response) {
                if (3 == response.responseJSON.code) {
                    modal.getModal.danger(__l.Error, response.responseJSON.message, true, null, null, null, null, null, $loadingTarget)
                } else {
                    modal.getModal.danger(response.responseJSON.status, response.statusText, true)
                }
            },
            beforeSend: () => $loadingTarget && loading.show($loadingTarget),
            complete: () => $loadingTarget && loading.hide($loadingTarget)
        })
    },
    getLinkGridFile(info, magic, columnIndex, itemIndex, $loadingTarget = null, callback) {
        $.ajax({
            type: "POST",
            url: __root + "Grid/GridGetLinkFile",
            datatype: "json",
            traditional: true,
            data: {
                info: info,
                magic: magic,
                columnIndex: columnIndex,
                itemIndex: itemIndex,
            },
            success: function (response) {
                if (response.code == gridResponseCodes.SUCCESS) {
                    callback && callback(response.message)
                }
                else {
                    modal.getModal.danger(__l.Error, response.message, true)
                }
            },
            beforeSend: function () { loading.show($loadingTarget) },
            complete: function () { loading.hide($loadingTarget) }
        })
    },
    downloadGridAllFiles(info, magic, columnIndex, $loadingTarget = null) {
        $.ajax({
            type: "POST",
            url: window.location.origin + __root + 'Grid/GridDownLoadAllFiles',
            xhr: function () {
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 2) {
                        if (xhr.status == 500) {
                            xhr.responseType = "text";
                        } else {
                            xhr.responseType = "blob";
                        }
                    }
                };
                return xhr;
            },
            traditional: true,
            data: {
                info: info,
                magic: magic,
                columnIndex: columnIndex,
            },
            success: function (response, textStatus, request) {
                controls.parseDownloadFileResponse(response, textStatus, request, false)
            },
            error: function (response) {
                if (3 == response.responseJSON.code) {
                    modal.getModal.danger(__l.Error, response.responseJSON.message, true, null, null, null, null, null, $loadingTarget)
                } else {
                    modal.getModal.danger(response.responseJSON.status, response.statusText, true)
                }
            },
            beforeSend: () => $loadingTarget && loading.show($loadingTarget),
            complete: () => $loadingTarget && loading.hide($loadingTarget)
        })
    },
    recalculateGridTableHeaderOffets($grid) {
        $grid.find('thead tr').each((i, e) => {
            let topMenuHeight = 0
            let prevsHeight = 0

            $(e).prevUntil().each((x, d) => prevsHeight += $(d).outerHeight(true))

            if ($grid.closest('.modal').length != 0 || $grid.find('.kdr-grid-scroll-horizontal').length != 0 || $grid.hasClass('kdr-grid-fullscreen')) {
                topMenuHeight == 0
            }
            else {
                $('.content-header > :not([id^="info"])').each((x, d) => topMenuHeight += $(d).outerHeight())
            }

            let totalHeight = prevsHeight + topMenuHeight
            $(e).find('th').css('top', totalHeight)
        })
    },
    /**
     * 
     * @param {any} $grid target control
     * @param {any} callback without argument
     */
    lockCheckboxes($grid, callback) {
        let payload
        if ($grid.hasClass('kdr-grid-modal')) {
            payload = $grid.find(".kdr-grid-item-select .kdr-grid-checkbox-list").map((a, b) => { return { columnIndex: $(b).data("index"), state: $(b).valExtended(), magic: $(b).data("action") } })
        } else if ($grid.find('.kdr-grid-item-update .kdr-grid-checkbox-list').length > 0) {
            payload = $grid.find(".kdr-grid-item-update .kdr-grid-checkbox-list").map((a, b) => { return { columnIndex: $(b).data("index"), state: $(b).valExtended(), magic: $(b).closest("tr").find(".kdr-grid-checkbox-list-action").data("action") } })
        } else {
            ///grid bez updata ale z checkboxami
            payload = $grid.find(".kdr-grid-item-select .kdr-grid-checkbox-list").map((a, b) => { return { columnIndex: $(b).data("index"), state: $(b).valExtended(), magic: $(b).closest("tr").find(".kdr-grid-checkbox-list-action").data("action") } })
        }


        let formData = new FormData();
        formData.append('info', controls.getInfo($grid))
        formData.append('payload', JSON.stringify(payload.toArray()))

        $.ajax({
            type: "POST",
            url: __root + "Grid/LockCheckboxes",
            datatype: "json",
            traditional: true,
            contentType: false,
            processData: false,
            data: formData,
            success: function (response) {
                if (response.code == gridResponseCodes.SUCCESS) {
                    controls.setInfo($grid, response.info)
                    callback && callback()
                }
                else {
                    modal.getModal.danger(__l.Error, response.message, true)
                }
            }//,
            //beforeSend: function () { showLoading() },
            //complete: function () { loading.hide($loadingTarget) }
        })
    },
    toggleCheckboxFilter($grid, selectedCheckboxColumnMagic, callback) {
        $.ajax({
            type: "POST",
            url: window.location.origin + __root + 'Grid/ToggleCheckboxFilter',
            datatype: "json",
            traditional: true,
            data: {
                info: controls.getInfo($grid),
                columnMagic: selectedCheckboxColumnMagic
            },
            success: function (response) {
                if (3 != response.code) {
                    controls.setInfo($grid, response.info)
                    callback && callback()
                } else {
                    modal.getModal.danger(__l.Error, response.message, true)
                }
            },
        })
    },
    initTableColumnResizer($headers, resizedCallback) {
        function _createResizableColumn(header, resizer) {
            // Track the current position of mouse
            let x = 0;
            let w = 0;


            let previousWidth;

            const saveChanges = function () {
                if (previousWidth !== parseInt($(header).css('width'))) {
                    resizedCallback && resizedCallback(header)
                }
            }

            const mouseDownHandler = function (e) {
                // Get the current mouse position
                x = e.clientX;

                // Calculate the current width of column
                const styles = window.getComputedStyle(header);
                w = parseInt(styles.width, 10);
                previousWidth = w

                // Attach listeners for document's events
                document.addEventListener('mousemove', mouseMoveHandler);
                document.addEventListener('mouseup', mouseUpHandler);
            };

            const mouseMoveHandler = function (e) {
                // Determine how far the mouse has been moved
                const dx = e.clientX - x;
                let widthToSet = `${w + dx}px`

                // Update the width of column
                $(header).css('width', widthToSet)
                $(header).css('min-width', widthToSet)
            };

            // Reset width on double click
            const dblMouseClick = function (e) {
                $(header).css('width', '')
                $(header).css('min-width', '')
                previousWidth = -1
                saveChanges()
            }



            // When user releases the mouse, remove the existing event listeners
            const mouseUpHandler = function () {
                document.removeEventListener('mousemove', mouseMoveHandler);
                document.removeEventListener('mouseup', mouseUpHandler);
                saveChanges()
            };

            resizer.addEventListener('mousedown', mouseDownHandler);
            resizer.addEventListener('dblclick', dblMouseClick);
        }
        $headers.each((i, e) => {
            const resizer = document.createElement('div');
            resizer.classList.add('resizer');
            $(e).append(resizer)
            _createResizableColumn(e, resizer);
        })
    },
    initStickedTableCells($control) {

        let $spacedColumns = [];
        function _getSpacing($arrayOfItems, itemIndex, rowIndex, isThead, position, $parentRow) {
            let spacing = 0 //= $previousCell.outerWidth() + parseInt($previousCell.css('left'))
            if (itemIndex == 0 && rowIndex == 0) {
                spacing = 0
            } else {
                function __calculate() {
                    for (j = itemIndex - 1; j >= 0; --j) {
                        let $item = $arrayOfItems.eq(j)
                        spacing += Math.ceil($item.outerWidth()) - 1 //Ceil is for chrome compatibility with Firefox
                    }
                }

                function __getDistance($element, $item, p = position) {
                    let d;
                    if (p == 'right') {
                        d = $element.getPositionInViewport()[p] - $item.getPositionInViewport()[p]
                    } else {
                        d = $item.getPositionInViewport()[p] - $element.getPositionInViewport()[p]
                    }
                    return d
                }
                function __findAndSetPreviousRowItemOffset($item) {
                    let colId = $item.data('columnMagic')
                    let prevColumnCellToSetOffset = columnsToSetOffset.find((e) => e.$item.data('columnMagic') == colId && e.$item.parent().hasClass('kdr-grid-header-row') == false)
                    if (prevColumnCellToSetOffset != undefined && prevColumnCellToSetOffset.$item.attr('colspan') == $item.attr('colspan') && prevColumnCellToSetOffset.$item.index() && $item.index()) {
                        //console.log(colId)
                        spacing = prevColumnCellToSetOffset.offset
                        return true
                    } else {
                        return false
                    }
                }

                if (isThead) {
                    if (rowIndex == 0) {
                        __calculate()
                    } else {
                        if (itemIndex == 0) {

                            let el = {
                                $element: null,
                                distance: 0,
                                offset: 0
                            }

                            $($spacedColumns[rowIndex - 1]).filter((a, b) => b.$item.hasClass(`st-auto-${position}`)).each((i, e) => {
                                let $e = e.$item
                                let distance = __getDistance($e, $arrayOfItems.eq(itemIndex));

                                if (i == 0 && distance >= 0) {
                                    el.$element = $e
                                    el.distance = distance
                                    el.offset = e.offset
                                } else if ((distance >= 0 && distance <= el.distance) || (el.$element == null && (distance > -1))) {
                                    el.$element = $e
                                    el.distance = distance
                                    el.offset = e.offset

                                    if (distance == 0) {
                                        return false
                                    }
                                }
                            })

                            let offset = el.$element == null ? el.distance : parseInt(el.offset)
                            spacing += offset

                            if (position == 'left') {
                                if (el.$element != null && __getDistance(el.$element, $arrayOfItems.eq(itemIndex), 'left') != 0) {
                                    spacing += el.$element.outerWidth()
                                }
                            } else {
                                if (el.$element != null && __getDistance(el.$element, $arrayOfItems.eq(itemIndex), 'right') > 0) {
                                    spacing += el.$element.outerWidth()
                                }
                            }
                        } else {
                            let $item = $arrayOfItems.eq(itemIndex - 1)

                            let col = $(columnsToSetOffset).map(function (x, y) {
                                if (y.$item[0] == $item[0]) {
                                    return y
                                }
                            })[0]

                            spacing += col.offset
                            spacing += $item.outerWidth()
                        }
                    }
                } else {
                    let isFirstRow = $parentRow.is(':first-child')
                    if (isFirstRow == true || (isFirstRow == false && __findAndSetPreviousRowItemOffset($arrayOfItems.eq(itemIndex)) == false)) {
                        __calculate()
                    }
                }
            }
            return spacing
        }

        function _isThead($item) {
            return $item.closest('thead').length > 0
        }
        function _manageCell($item, index, rowIndex, $items, $parentRow) {
            let isThead = _isThead($item)
            let isLeft = $item.hasClass('st-auto-left')
            let side = isLeft ? 'left' : 'right'
            let offset = _getSpacing($items, index, rowIndex, isThead, side, $parentRow)

            columnsToSetOffset.push({
                $item: $item,
                position: side,
                offset: offset
            })

            if (isThead) {
                if ($spacedColumns[rowIndex] == undefined) {
                    $spacedColumns[rowIndex] = []
                }
                $spacedColumns[rowIndex].push({
                    $item: $item,
                    offset: offset
                })
            }
        }

        let columnsToSetOffset = []

        $control.find('.kdr-grid-layout > thead, .kdr-grid-layout > tbody, .kdr-grid-layout > tfoot,'
            + '.kdr-incell-table-layout > thead, .kdr-incell-table-layout > tbody, .kdr-incell-table-layout > tfoot')
            .find('> tr.kdr-grid-item-select, > tr.kdr-grid-item-update, > tr.kdr-grid-item-insert, > tr.kdr-grid-footer, > tr.kdr-grid-header-row,'
                + '> .kdr-incell-item-row, > .kdr-incell-header-row')
            .each((rowIndex, e) => {
                let $row = convert.toJqueryObject(e)
                let $stAutoLeftItems = $row.find('.st-auto-left')
                let $stAutoRightItems = $row.find('.st-auto-right').reverse()

                $stAutoLeftItems.each((j, f) => {
                    _manageCell($(f), j, rowIndex, $stAutoLeftItems, $row)
                })
                $stAutoRightItems.each((j, f) => {
                    _manageCell($(f), j, rowIndex, $stAutoRightItems, $row)
                })
            })
        $(columnsToSetOffset).each((i, e) => {
            e.$item.css(e.position, e.offset)
        })
    },
    filters: {
        initUI($filter) {
            let $inputDDL = $filter.find('[class*="ds-ddl-"]')
            let $inputCB = $filter.find('[class*="ds-"]:not([class*="ds-ddl-"])');

            $inputDDL.each(function () {
                disabler.disableBasedOnDDL($(this));
            });

            $inputCB.each(function () {
                disabler.disableBasedOnCheckbox($(this));
            });
        }
    },
    link: {
        postToUrl(url, params) {
            let form = document.createElement('form');
            form.setAttribute('method', 'post');
            form.setAttribute('action', url);

            for (let key in params) {
                if (params.hasOwnProperty(key)) {
                    let input = document.createElement('input');

                    input.setAttribute('type', 'hidden');
                    input.setAttribute('name', key);
                    input.setAttribute('value', params[key]);

                    form.appendChild(input);
                }
            }

            document.body.appendChild(form);
            form.submit();
        },
        onClickPostLink($button) {
            controls.link.postToUrl(__root + $button.data('href'), {
                p: $button.data('p'),
                info: controls.getInfo($button.closest('.kdr-grid'))
            });

            return false; //To jest po to by domyslnie nie wykonal sie get na <a>
        }
    }
}

$(document)
    .on('change', '.kdr-custom-radio[data-unchecker="true"]', function () {
        let $radioInput = $(this)
        let groupName = $radioInput.attr('name')
        //let $radioContainer = $radioInput.closest('.custom-radio')
        let $unchecker = $radioInput.next()
        //$radioContainer.append($unchecker)
        $(`.kdr-custom-radio[name="${groupName}"] + .radio-buttons-unchecker:visible`).hide().tooltip('hide')
        $unchecker.fadeIn(125)

    })
    .on('click', '.radio-buttons-unchecker', function () {
        let $unchecker = $(this)
        let $wrapper = $unchecker.closest('.radio-buttons-wrapper');

        if (!$wrapper.length) {
            $wrapper = $unchecker.closest('.radio-buttons-wrapper-td');
        }

        $wrapper.find('.kdr-custom-radio:checked').prop('checked', false).trigger('change')
        $unchecker
            .hide()
            .tooltip('hide')
    })


function convertWordFakeListsToUl(html) {
    const listParagraphRegex = /<p([^>]*)>([\s\S]*?)<\/p>/gi;
    const msoListRegex = /mso-list:l(\d+) level(\d+) lfo(\d+)/m;

    let result = '';
    let lastIndex = 0;
    let inList = false;
    let currentListType = null;
    let currentOlType = null;
    var listElements = [];

    let match;
    while ((match = listParagraphRegex.exec(html)) !== null) {
        const fullMatch = match[0];
        const attrs = match[1] || '';
        let inner = match[2] || '';
        let romanListP = false;
        let listSpecs = null;

        let listSpecsMatch = msoListRegex.exec(fullMatch)
        //let listSpecs = null;

        if (listSpecsMatch) {
            listSpecs = {
                id: listSpecsMatch[1],
                lvl: listSpecsMatch[2],
                frmt: listSpecsMatch[3]
            }

            listElements.push(listSpecs)
        }

        const isListPara =
            /class="[^"]*MsoListParagraph[^"]*"/i.test(attrs) ||
            /mso-list:/i.test(attrs);

        let marker = null;

        if (isListPara) {
            result += html.substring(lastIndex, match.index);

            const markerSpanRegex = /<span[^>]*mso-list:\s*Ignore[^>]*>([\s\S]*?)<\/span>/i;
            var markerMatch = inner.match(markerSpanRegex);
            if (markerMatch && markerMatch[1].startsWith('<span')) {
                //inner = inner.replace(markerMatch[1] + '</span>', '')

                //markerMatch = inner.match(markerSpanRegex);
                const parser = new DOMParser();
                const doc = parser.parseFromString(inner, 'text/html');

                const span = Array.from(doc.querySelectorAll('span'))
                    .find(s => /mso-list:\s*Ignore/i.test(s.getAttribute('style')));

                if (span) {
                    const listNumber = span.textContent.replace(/\u00A0/g, '').trim(); 

                    if (listNumber) {
                        console.log('Znaleziony numer listy:', listNumber); 
                        marker = listNumber
                        romanListP = true;
                    }

                    span.remove();
                }

                inner = doc.body.innerHTML;
            }

            if (markerMatch && marker == null) {
                marker = markerMatch[1]
                    .replace(/&nbsp;/gi, ' ')
                    .replace(/<[^>]+>/g, '')
                    .trim();
                inner = inner.replace(markerSpanRegex, '');
            }

            let text = inner
                .replace(/&nbsp;/gi, ' ')
                .replace(/^[\s\u00B7\u2022\u25CF\u2219\u22C5\-*\+]+/i, '')
                .trim();

            text = text.replace(
                /^<span[^>]*>[\u00B7\u2022\u25CF\u2219\u22C5\-*\+]\s*<\/span>\s*/i,
                ''
            );

            const styleMatch = attrs.match(/style="([^"]*)"/i);
            let style = styleMatch ? styleMatch[1] : '';

            if (style) {
                style = style
                    .replace(/\bmso-[a-z-]+:[^;"]*;?/gi, '')
                    .replace(/;;+/g, ';')
                    .trim()
                    .replace(/^;|;$/g, '');
            }

            let detectedListType = 'ul';
            let detectedOlType = null;

            if (marker) {
                const letterMatch = marker.match(/^([a-zA-Z])[\.\)]?$/);
                const digitMatch = marker.match(/^(\d+)[\.\)]?$/);
                const romanMatch = marker.match(/^([IVXLCDM]+)[\.\)]?$/i);
                const subDigitMatch = marker.match(/^(\d+(?:\.\d+)*)$/);

                if (letterMatch && !romanListP) {
                    detectedListType = 'ol';
                    detectedOlType = letterMatch[1] === letterMatch[1].toLowerCase() ? 'a' : 'A';
                } else if (digitMatch) {
                    detectedListType = 'ol';
                    detectedOlType = null;
                } else if (romanMatch) {
                    detectedListType = 'ol';
                    detectedOlType = romanMatch[1] === romanMatch[1].toLowerCase() ? 'i' : 'I';
                } else if (subDigitMatch) {
                    detectedListType = 'ol';
                    detectedOlType = 'a';
                }

            }

            if (!inList || detectedListType !== currentListType || detectedOlType !== currentOlType) {
                if (inList) {
                    if (currentListType === 'ol') {
                        result += '</ol>';
                    } else {
                        result += '</ul>';
                    }
                }

                currentListType = detectedListType;
                currentOlType = detectedOlType;
                inList = true;

                var count = 1
                if (listSpecs && listElements.length > 0) {
                    count = listElements.filter(item => item.id === listSpecs.id).length;
                }

                if (currentListType === 'ol') {
                    if (currentOlType === 'a' || currentOlType === 'A' || currentOlType === 'i' || currentOlType === 'I') {
                        result += '<ol type="' + currentOlType + '" start="' + count + '">';
                    } else {
                        result += '<ol start="' + count + '">';
                    }
                } else {
                    result += '<ul start="' + count + '">';
                }
            }

            if (style) {
                result += '<li style="' + style + '">' + text + '</li>';
            } else {
                result += '<li>' + text + '</li>';
            }

            lastIndex = listParagraphRegex.lastIndex;
        } else {
            if (inList) {
                if (currentListType === 'ol') {
                    result += '</ol>';
                } else {
                    result += '</ul>';
                }
                inList = false;
                currentListType = null;
                currentOlType = null;
            }
            result += html.substring(lastIndex, listParagraphRegex.lastIndex);
            lastIndex = listParagraphRegex.lastIndex;
        }
    }

    if (inList) {
        if (currentListType === 'ol') {
            result += '</ol>';
        } else {
            result += '</ul>';
        }
    }

    result += html.substring(lastIndex);

    return result;
}


//#endregion Controls